import { render } from "./mobile-layout.vue?vue&type=template&id=4d32c810"
import script from "./mobile-layout.vue?vue&type=script&lang=js"
export * from "./mobile-layout.vue?vue&type=script&lang=js"

import "./mobile-layout.vue?vue&type=style&index=0&id=4d32c810&lang=scss"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__